import { Component } from '@angular/core';
import { Notification } from '../../models/common.model';
import { NotificationService } from '../../core.index';
@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
export class NotificationComponent {

  constructor(public notificationService:NotificationService){}

  ngOnInit() {
    this.autoDismissAlerts();
  }


  handleOnClose(dismissedAlert: Notification) {
    dismissedAlert.dismissible = false;
    setTimeout(() => {
      this.notificationService.message = this.notificationService.message.filter(alert => alert !== dismissedAlert);
    }, 300);
  }

  trackById(index: number, alert: Notification) {
    return alert.count;
  }


  autoDismissAlerts() {
    this.notificationService.message.forEach((alert: Notification) => {
      alert.dismissible = true; // Show the alert with the animation

      setTimeout(() => {
        alert.dismissible = false; // Start hiding the alert
        setTimeout(() => {
          this.handleOnClose(alert); // Remove the alert after the animation
        }, 300); // Delay the removal to match the animation duration
      }, alert.timeout || 5000); // Timeout from the notification service
    });
  }
}
